import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="min-h-[60vh] flex items-center justify-center bg-[var(--cream)] px-5">
      <div className="text-center">
        <p className="eyebrow mb-3">404</p>
        <h1 className="font-display text-5xl text-[var(--charcoal)]">Page Not Found</h1>
        <p className="text-[var(--charcoal-soft)] mt-4 max-w-md mx-auto">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/" className="btn-gold rounded-full px-8 py-3.5 inline-block mt-7">Back to Home</Link>
      </div>
    </section>
  );
}
